import { BillingAccountProperties } from './BillingAccountProperties';

export class BillingAccount {
    billingaccounts: Array<BillingAccountProperties>;

    public static Make(obj: any): BillingAccount {
        const billingAccount = new BillingAccount();
        Object.assign(billingAccount, obj);
        return billingAccount;
    }
}
